import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";

const SportsEvents = () => {
  const [events, setEvents] = useState([]);

  const fetchEvents = useCallback(async () => {
    try {
      const res = await axios.get("https://admin.stipsredu.in/api/sports/all");
      const data = res.data.events || res.data;
      setEvents((prev) =>
        JSON.stringify(prev) === JSON.stringify(data) ? prev : data
      );
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  }, []);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-extrabold text-center text-indigo-900 mb-12 tracking-tight">
          Sports Events
        </h1>

        {events.length === 0 ? (
          <div className="text-center py-16 text-gray-500 text-xl font-medium">
            No sports events available at the moment...
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
            {events.map((event) => (
              <div
                key={event._id}
                className="group w-full max-w-[420px] bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
              >
                {/* Image with overlay gradient */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={`https://admin.stipsredu.in/uploads/sports/${event.image}`}
                    alt={event.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                    onError={(e) => {
                      console.log("Image failed:", e.currentTarget.src);
                      if (e.currentTarget.dataset.fallback) return;
                      e.currentTarget.dataset.fallback = "true";
                      e.currentTarget.src =
                        "https://via.placeholder.com/420x224?text=Event+Image+Not+Found";
                    }}
                  />
                  {/* Subtle gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-60 group-hover:opacity-70 transition-opacity duration-300" />
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-indigo-900 mb-3 line-clamp-2">
                    {event.title}
                  </h3>

                  <div className="flex items-center gap-6 text-sm text-gray-600 mb-4">
                    <div className="flex items-center">
                      <span className="mr-1">📅</span> {event.date}
                    </div>
                    <div className="flex items-center">
                      <span className="mr-1">⏰</span> {event.time}
                    </div>
                  </div>

                  <p className="text-gray-700 leading-relaxed line-clamp-4">
                    {event.description}
                  </p>
                </div>

                {/* Optional footer / CTA */}
                {/* <div className="px-6 pb-6">
                  <button className="w-full py-3 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700 transition-colors duration-200">
                    View Details
                  </button>
                </div> */}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SportsEvents;